<template>
  <div id="doctorF">
    <div id="doctor">
      <BannerSwiper msg="专家介绍"></BannerSwiper>

      <div id="body">
        <div style="width:100%;height:50px;padding-top:30px">
          <breadcrumb msg="专家介绍"></breadcrumb>
        </div>
        <div
          style="padding-top:0px;text-align:center;font-size:30px;font-family: dasongbiao;color: rgb(69, 109, 171);"
        >专家介绍</div>

        <div id="doctorBar">
          <span
            :class="item.name == name ? 'on' : 'off'"
            @click="openType(item)"
            v-for="item in list"
            :key="item.id"
          >
            <a
              :class="item.name == name ? 'on' : 'off'"
              :href="herf"
              style="color: black;text-decoration: none;text-align: center;width: 100%;font-family: dasongbiao"
            >{{item.name}}</a>
          </span>
        </div>
        <div id="a">
          <div class="aName" id="aName2">
            <img src="../assets/img/arr2.png" alt /> 上级专家
          </div>
          <div id="a1">
            <div id="bodyList" v-for="item in doctorBossList" :key="item.id">
              <div id="name">{{item.name}}</div>
              <div id="line"></div>
              <div id="Body">
                <div
                  id="doctorList"
                  v-for="itemCh in item.doctorForms"
                  :key="itemCh.id"
                  @click="open1(itemCh.id)"
                >{{itemCh.name}}</div>
              </div>
            </div>
          </div>
        </div>
        <div id="a">
          <div class="aName" id="aName1">
            <img src="../assets/img/arr2.png" alt /> 本院团队
          </div>
          <div id="a1">
            <div id="bodyList" v-for="item in doctorList" :key="item.id">
              <div id="name">{{item.name}}</div>
              <div id="line"></div>
              <div id="Body">
                <div
                  id="doctorList"
                  v-for="itemCh in item.doctorForms"
                  :key="itemCh.id"
                  @click="open1(itemCh.id)"
                >{{itemCh.name}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div id="a">
          <div class="aName" id="aName2">
            <img src="../assets/img/arr2.png" alt /> 上级专家
          </div>
          <div id="a1">
            <div id="bodyList" v-for="item in doctorBossList" :key="item.id">
              <div id="name">{{item.name}}</div>
              <div id="line"></div>
              <div id="Body">
                <div
                  id="doctorList"
                  v-for="itemCh in item.doctorForms"
                  :key="itemCh.id"
                  @click="open1(itemCh.id)"
                >{{itemCh.name}}</div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import BannerSwiper from "../components/bannerSwiper";
import breadcrumb from "../components/breadcrumb";
export default {
  components: { breadcrumb, BannerSwiper },
  data() {
    return {
      doctorList: JSON.parse(sessionStorage.getItem("doctorList")),
      doctorBossList: JSON.parse(sessionStorage.getItem("doctorBossList")),
      list: [
        { id: 1, name: "上级专家", herf: "#aName2" },
        { id: 2, name: "本院团队", herf: "#aName1" }
      ],
      name: "上级专家",
      herf: "#aName1"
    };
  },
  methods: {
    open() {
      this.$router.push({ path: "/doctorList" });
    },
    open1(id) {
      this.$router.push({ path: "/leadership?id=" + id });
    },
    openType(item) {
      this.name = item.name;
      this.herf = item.herf;
      // console.log(1)
    }
  }
};
</script>
<style lang="less">
#doctorF {
  /deep/ #address {
    color: rgb(69,109,171) ;
  }
  /deep/ .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    color: rgb(69,109,171)  !important;
  }
  /deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
    color: rgb(69,109,171)  !important;
    font-weight: 600 !important;
  }
  /deep/ .el-breadcrumb__separator {
    color: rgb(69,109,171) !important;
  }
}
</style>
<style lang="less" scoped>
.on {
  background-image: url(../assets/img/btn2_a.png);
  background-size: 100% 100%;
  color: #ffffff !important;
}
.off {
  background-image: none;
}
#doctorBar {
  width: 600px;
  margin: 40px auto;
  text-align: center;
  display: flex;
  flex-direction: row;
  span {
    height: 40px;
    width: 200px;
    line-height: 40px;
    font-size: 22px;
    font-weight: 600;
    border: 2px solid #0f70a1;
    display: block;
    margin: 0 auto;
  }
  span:hover {
    background-image: url(../assets/img/btn2_a.png);
    background-size: 100% 100%;
    color: #ffffff;
  }
}
#doctor {
  width: 100%;
  background-image: url(../assets/img/czys1.jpg);
  background-size: 100% 100%;
  #body {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 40px;
  }
  #a {
    .aName {
      font-size: 28px;
    }
    #a1 {
      display: flex;
      display: -webkit-flex;
      // justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
      font-family: dasongbiao;
      #bodyList {
        // height: 90px;
        //   height: 200px;
        width: 300px;
        background-image: url(../assets/img/123444.png);
        background-size: 100% 100%;
        color: #ffffff;
        margin: 20px 30px;
        // margin-right: 60px;
        padding: 20px;
        #name {
          height: 30px;
          width: 100%;
          font-size: 22px;
          // padding-left: 8px;
          padding-top: 8PX;
          text-align: center;
        }
        #line {
          height: 10px;
          width: 100%;
          margin: 12px auto;
          background-image: url(../assets/img/bar6.png);
          background-size: 100% 100%;
        }
        #Body {
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          flex-direction: row;
          flex-wrap: wrap;
          div {
            font-size: 20px;
            width: 100px;
            display: inline;
            text-align: center;
            margin: 10px 0;
          }
        }
      }
    }
  }
}
#Body :hover {
  cursor: pointer;
  color: #ffffff;
}
</style>
